import { combineReducers } from 'redux';
import { generateByIdReducer, generateIdReducer } from 'helpers/jsonapi';
import { FETCH_PARTNERSHIP_PAYMENT_SUCCESS } from 'types/payment';
export default combineReducers({
    byId: generateByIdReducer([FETCH_PARTNERSHIP_PAYMENT_SUCCESS], ['partnershipPayment']),
    ids: generateIdReducer(FETCH_PARTNERSHIP_PAYMENT_SUCCESS, 'partnershipPayment'),
});
